var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBigMountain(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 207,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.176 43.5L286.1 77l-95.795-18L0 207h704v-40.5L489.907 0l-84.223 43.5h-76.508z",
    fill: "#191919"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigMountain);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='287' height='207' viewBox='0 0 287 207' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M329.176 43.5L286.1 77L190.305 59L0 207H704V166.5L489.907 0L405.684 43.5H329.176Z' fill='%23191919'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };